import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { INTEGRATION_WRAPPER_LOADING_STATES } from "../constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { setLoadingState, setFormAndTaxYearList, setAuthorizationUrl, setTenantList, setImportData, setIsImportDataGridViewLoaded, setFormSettings, componentKey as accountingsuitecomponentkey } from "./AccountingSuiteSlice";
import FormsDataService from "../../../../../services/FormsDataService";

export const{ getAccountingSuiteUrl, getFormAndTaxYearList, connectToAccountingSuite, getLoadImportData, getFormSetting, disconnectAccountingSuite } = {
    getAccountingSuiteUrl: (payload) => {
        return {
            type: "ACCOUNTINGSUITE/GET_AUTHENTICATEURL",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "ACCOUNTINGSUITE/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    connectToAccountingSuite: (payload) => {
        return {
            type: "ACCOUNTINGSUITE/GET_CONNECTACCOUNTINGSUITE",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "ACCOUNTINGSUITE/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "ACCOUNTINGSUITE/GET_FORM_SETTING",
            payload: payload
        }
    },
    disconnectAccountingSuite: (payload) => {
        return{
            type: "ACCOUNTINGSUITE/GET_DISCONNECTACCOUNTINGSUITE",
            payload: payload
        }
    }
}

function* getAccountingSuiteUrlAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.getAccountingSuiteUrl();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setAuthorizationUrl(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch AccountingSuite Url", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setFormAndTaxYearList(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* connectToAccountingSuiteAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.GetOrganizationDetails(action.payload);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                const tenantData = response?.data?.Data || null;
                yield put(setTenantList(tenantData));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to Connect Entrata",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to Connect Entrata", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                yield put(setImportData(response?.data?.Data));
                yield put(setIsImportDataGridViewLoaded(true));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Import Data",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_LOADING }));
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                if (response.data.Data) {
                    yield put(setFormSettings(response?.data?.Data));
                }
                else {
                    yield put(addNotifications({
                        heading: "Error",
                        message: "An error occurred while fetching the Data",
                        variant: TOASTER_VARIANT.DANGER
                    }));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}

function* disconnectAccountingSuiteAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { removedTenant } = action.payload;
        const response = yield IntegrationDataService.disconnectAccountingSuite(removedTenant);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(addNotifications({
                heading: "Disconnected",
                message: "You have been successfully disconnected.",
                variant: TOASTER_VARIANT.SUCCESS
            }))
            yield put(setTenantList(null));
        }
    }
    catch {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getAccountingSuiteUrl().type, getAccountingSuiteUrlAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(connectToAccountingSuite().type, connectToAccountingSuiteAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
        takeLatest(disconnectAccountingSuite().type, disconnectAccountingSuiteAsync),
    ]);
}
store.sagaManager.addSaga(accountingsuitecomponentkey, rootSaga);